// extracted by mini-css-extract-plugin
export default {"add_product_form":"AddProductModal_add_product_form__BOrq3","add_produc_name_modal":"AddProductModal_add_produc_name_modal__PepDP"};